import type { MutableRefObject } from "react";
import { useRef } from "react";

export function useDepSafeValue<T>(value: T): MutableRefObject<T> {
  const valueRef = useRef<T>(value);
  valueRef.current = value;
  return valueRef;
}
